import { UntypedFormGroup } from "@angular/forms";

export class FormHelper {

  public static markFormGroupTouched(formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  public static getFormValidationErrors(form: UntypedFormGroup): string[] {
    const errors: string[] = [];

    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);

      if (control && control.errors) {
        Object.keys(control.errors).forEach(errorKey => {
          const errorValue = control.errors?.[errorKey];
          errors.push(`Control '${key}' has error '${errorKey}': ${JSON.stringify(errorValue)}`);
        });
      }
    });

    return errors;
  }
}
